import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { ILinkItemDataModel } from '../../models/link-item.datamodel';
import { Swiper } from 'swiper';
import { JssStylingService } from '../../jss-styling.service';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-block-action',
  templateUrl: './block-action.component.html',
  styleUrls: ['./block-action.component.scss']
})
export class BlockActionComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  link: ILinkItemDataModel;
  SecondaryLink: ILinkItemDataModel;
  swiper: Swiper;
  dynamicClass: string;
  public contextSubscription: Subscription;
  language:string;
  constructor( public jssStylingService: JssStylingService,public jssContext: JssContextService) { }

  ngOnInit() {
    let fields: any = this.rendering.fields as any;
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });

    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    if(fields){
      this.link={
        href: fields?.Link['value']?.href,
        target: fields?.Link['value']?.target,
        text: fields?.Link['value']?.text
      }
      this.SecondaryLink={
        href: fields?.SecondaryLink['value']?.href,
        target: fields?.SecondaryLink['value']?.target,
        text: fields?.SecondaryLink['value']?.text
      }
    }
    this.swiper = new Swiper(".pb-swiper-slider-mobile", {
      slidesPerView: 'auto',
      freeMode: true,
      centeredSlides: false,
      spaceBetween: 16,
      grabCursor: true,
      breakpoints: {
        1280: {
            enabled: false,
        }
      },
    });
    

  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
  }
}
